// extracted by mini-css-extract-plugin
export default {"badge":"Budge_badge__Jpuhp","text":"Budge_text__tgh7R","badge--clearable":"Budge_badge--clearable__eoy0m","remover":"Budge_remover__Nd9hU","cross":"Budge_cross__N71fs"};